import { ApiPaths } from './ApiPaths';
import BaseApi from './BaseApi';

/**
 * API for managing workflow information
 * @param {String} baseURL
 */
const create = () => {  // this will change for prod deployment
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create({
        timeout: 60000
    });

    const resetInterviewTask = (ticketId) => api.deleteRequest(ApiPaths.RESET_INTERVIEW(ticketId));
    const repairMissingInterviewFile = (ticketId) => api.put(ApiPaths.REPAIR_INTERVIEW(ticketId), null);

    // Return back a collection of functions
    return {
        resetInterviewTask, repairMissingInterviewFile
    }
}

// let's return back our create method as the default.
export default {
    create
}
